module.exports = __webpack_public_path__ + "static/sensation-logo-eb489431bd8510bdc4a4154fac84f7bd.png";